/**
 * Handles an input change for a text cell: updates local input state and
 * emits the new value upward, forwarding the originating cell `type`.
 *
 * @param e - The input change event.
 * @param id - Row identifier associated with the edited cell.
 * @param setInputValue - Local state setter for the controlled input.
 * @param onValueChangeOfTextField - Upstream callback notified with the new
 *   value, row id, and cell type.
 * @param type - Optional cell-type identifier forwarded to the callback so
 *   consumers can distinguish which column emitted the change.
 */
export const handleInputChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  id: string,
  setInputValue: (value: string) => void,
  onValueChangeOfTextField: (value: string, id: string, type?: string) => void,
  type?: string,
) => {
  setInputValue(e.target.value);
  onValueChangeOfTextField(e.target.value, id, type);
};
